<div>
  <div class="wm-notification-msg">{{msg}}</div>
  <div class="wm-notification-btns">
    <button pButton class="p-button-outlined"  (click)="close()">{{btnText}}</button>
  </div>
</div>
